import {
  notifyError,
  useNotifications,
  notifySuccess,
} from 'Logic/Notifications.js'
import { useMutation } from 'Data/Api'
import { useDataValue, useDataChange } from 'Simple/Data.js'
import mutationCreateTag from './mutation-create-tag.graphql.js'
import mutationUpdateTag from './mutation-update-tag.graphql.js'
import mutationDeleteTag from './mutation-delete-tag.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()

  let [, executeMutationCreateTag] = useMutation(mutationCreateTag)
  let [, executeMutationUpdateTag] = useMutation(mutationUpdateTag)
  let [, executeMutationDeleteTag] = useMutation(mutationDeleteTag)

  let tagsChange = useDataChange({
    context: 'form',
    path: 'tags',
    viewPath: props.viewPath,
  })

  let tags = useDataValue({
    context: 'form',
    path: 'tags',
    viewPath: props.viewPath,
  })

  return async function onSubmit({ args, change, value }) {
    switch (args.type) {
      case 'create_tag': {
        let {
          data: { insert_tasks_tags_one: tag },
          error,
        } = await executeMutationCreateTag({
          name: args.value.name,
        })

        if (error) {
          console.error('Error creating tag:', error)
          notify(notifyError('Cannot create tag due to an error'))
          return
        }

        tagsChange([...tags, tag])

        break
      }

      case 'open_edit_tag': {
        change(next => {
          next.edit_tag.open = true
          next.edit_tag.name = args.value.name
          next.edit_tag.id = args.value.id
        })
        break
      }

      case 'cancel_edit_tag': {
        change(next => {
          next.edit_tag.open = false
          next.edit_tag.name = ''
          next.edit_tag.id = null
        })
        break
      }

      case 'save_edit_tag': {
        let { error } = await executeMutationUpdateTag({
          id: value.edit_tag.id,
          name: value.edit_tag.name,
        })

        if (error) {
          console.error('Error updating tag:', error)
          notify(notifyError('Cannot update tag due to an error'))
          return
        }

        notify(notifySuccess(`Tag "${value.edit_tag.name}" updated.`))

        tagsChange([
          ...tags.filter(tag => tag.id !== value.edit_tag.id),
          {
            id: value.edit_tag.id,
            name: value.edit_tag.name,
          },
        ])

        change(next => {
          next.edit_tag.open = false
          next.edit_tag.name = ''
          next.edit_tag.id = null
        })

        break
      }

      case 'delete_tag': {
        let { error } = await executeMutationDeleteTag({
          id: args.id,
        })

        if (error) {
          notify(
            notifyError(
              "Error while deleting tag. Isn't the tag used in any task?"
            )
          )
          return
        }

        notify(notifySuccess(`Tag deleted.`))

        break
      }

      default:
    }
  }
}
